import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Mailbox = createSvgIcon(
  <path d="M18 9.75h4.5V24h-21V13.875A4.125 4.125 0 0 1 5.625 9.75H15.75V7.5H10.5V0H18v9.75Zm-2.25-7.5h-3v3h3v-3ZM18 15.75h-2.25V12H5.625c-1.036 0-1.875.84-1.875 1.875v7.875h16.5V12H18v3.75Z" />,
  'Mailbox'
);

export { Mailbox };